import React from 'react';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';

export const MobileChargeDetail: React.FC<{
  transkey: string;
  keyValues: Record<string, any>;
}> = ({ transkey, keyValues }) => {
  return (
    <Text dataHook={`charge-details__${transkey}`} secondary>
      <Box marginBottom="SP1" display="block">
        <Trans
          i18nKey={`charge-locator.results-page.field-name.${transkey}`}
          values={keyValues}
        >
          charge-locator.results-page.
          <Text tagName="div" secondary={false} weight="normal">
            field-name.{transkey}
          </Text>
        </Trans>
      </Box>
    </Text>
  );
};
